export default __webpack_public_path__ + "static/imgHome2-1263b22f6e0211add518530df61085e7.png";